var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00149 13.2881C6.80027 14.1865 5.92006 15.4917 5.56439 17H0.50909C0.227928 17 0 16.7721 0 16.4909V15.7924C0 13.3666 1.96656 11.4 4.39244 11.4C5.88755 11.4 7.20818 12.147 8.00149 13.2881Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18764 7.8C7.18764 9.34639 5.93619 10.6 4.39245 10.6C2.84871 10.6 1.59726 9.34639 1.59726 7.8C1.59726 6.2536 2.84871 5 4.39245 5C5.93619 5 7.18764 6.2536 7.18764 7.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4299 17C18.1262 15.4332 17.2391 14.0705 16 13.1402C16.816 12.0818 18.0965 11.4 19.5363 11.4C22.0009 11.4 23.9988 13.398 23.9988 15.8626V16.4909C23.9988 16.7721 23.7709 17 23.4898 17H18.4299Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3762 7.8C22.3762 9.34639 21.1047 10.6 19.5364 10.6C17.968 10.6 16.6965 9.34639 16.6965 7.8C16.6965 6.2536 17.968 5 19.5364 5C21.1047 5 22.3762 6.2536 22.3762 7.8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18.5C6.5 15.4624 8.96243 13 12 13C15.0376 13 17.5 15.4624 17.5 18.5V19.3636C17.5 19.7151 17.2151 20 16.8636 20H7.13636C6.78491 20 6.5 19.7151 6.5 19.3636V18.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.5C15.5 10.433 13.933 12 12 12C10.067 12 8.5 10.433 8.5 8.5C8.5 6.567 10.067 5 12 5C13.933 5 15.5 6.567 15.5 8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.5d9e118b0bfbe83c8ecb830f22930cb0.svg";
export { ForwardRef as ReactComponent };